import { blue, orange } from "@mui/material/colors";
import CssBaseline from "@mui/material/CssBaseline";
import { zhCN } from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Home";
import { apiInit } from "./services/api.service";
import { colorMode, login } from "./services/app.service";
import LoginForm from "./ui/LoginForm";
import Snker from "./ui/Snker";
import WebSiteHome from "./website/WebSiteHome";
import { MyProgress } from "./widgets/MyProgress";
import { HomeRoute } from "./HomeRoute";
apiInit();

export default function App() {
  const [isDark, setIsDark] = React.useState<boolean>(colorMode.isDark);
  useEffect(() => {
    const _sub = colorMode.sub.subscribe((v) => {
      colorMode.isDark = v;
      setIsDark(v);
    });
    return () => _sub.unsubscribe();
  });

  const theme = React.useMemo(() => {
    return createTheme(
      {
        palette: {
          mode: isDark ? "dark" : "light",
          primary: blue,
          secondary: orange,
        },
      },
      zhCN
    );
  }, [isDark]);

  React.useEffect(() => {
    login.getMe();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <CssBaseline />
        <Snker />
        <MyProgress />
        <LoginForm />
        <Routes>
          <Route path="1" element={<Home />} children={HomeRoute} />
          <Route path="*" element={<WebSiteHome />}></Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
